import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../../constants/Languages.js';
import Select from 'react-select';
import {Link} from 'react-router-dom';

import arrowCircleEmptyMedium from '../../../../assets/icons/arrow-circle-empty-medium.svg';

const CardSwitch = ({clang, headings, val, setHeadingOption, type, id}) => {
    const options = headings ? headings.map((heading, index) => {
                        return {
                            value: heading[heading.length - 1].link,
                            label: heading.map((option, indexOption) =>
                                      indexOption !== 0 ?
                                        indexOption === heading.length - 1 ?
                                        `${lang[clang].item.card[option.label] ? lang[clang].item.card[option.label] : option.label}`
                                        : `${lang[clang].item.card[option.label] ? lang[clang].item.card[option.label] : option.label}
                                          ${indexOption !== heading.length - 1 ? ' > ' : ''}`
                                        : '')
                        }}) : [];

    return (
        <div className="card__switch">
            {headings && headings[0] &&
              <div className="card__switch__headings">
                <label className="card__switch__label">{lang[clang].item.card[`${type}_in_heading`]} <span>{lang[clang].item.card[`in_heading`]}</span>:</label>
                <Select className="card__switch__select"
                    clearable={false}
                    deleteRemoves={false}
                    backspaceRemoves={false}
                    placeholder={lang[clang].item.card.choose_heading}
                    searchable={false}
                    options={options}
                    value={options.length > 1 ? val : options[0] || val}
                    onChange={setHeadingOption}/>
                <Link to={`${options.length > 1 ? val : options[0].value || val}`} className="card__switch__link" disabled={!(options.length > 1 ? val : options[0] || val)}>
                    <span className="card__switch__link-text">{lang[clang].item.card.go_heading}</span>
                    <img className="card__switch__link-img" src={arrowCircleEmptyMedium} alt="" />
                </Link>
              </div>}
              <div className="card__switch__headings">
                <label className="card__switch__label" dangerouslySetInnerHTML={{__html: lang[clang].item.card[`${type}_in_heading_results`]}}></label>
                <Link to={`/results?q=*&area=all&${type.toUpperCase().replace('-', '_')}_ID[0]=${id}`} className="card__switch__link">
                    <span className="card__switch__link-text">{lang[clang].item.card.show_results}</span>
                    <img className="card__switch__link-img" src={arrowCircleEmptyMedium} alt="" />
                </Link>
              </div>
        </div>
    );
};

CardSwitch.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(CardSwitch);



// WEBPACK FOOTER //
// ./src/components/items/cards/common/CardSwitch.js